import type { RouteRecordRaw } from 'vue-router'

// Every child of /e/:slug. The index ('') only exists to be redirected by the
// boot guard in EventApp: signed out -> welcome, not onboarded -> onboarding,
// else the last tab.
export const eventRoutes: RouteRecordRaw[] = [
  { path: '', name: 'event.home', component: () => import('./screens/Blank.vue') },
  { path: 'auth', name: 'event.auth', component: () => import('./screens/AuthLink.vue') },
  { path: 'welcome', name: 'event.welcome', component: () => import('./screens/Welcome.vue') },
  { path: 'signin', name: 'event.signin', component: () => import('./screens/SignIn.vue') },
  { path: 'onboarding', name: 'event.onboarding', component: () => import('./screens/Onboarding.vue') },
  { path: 'people', name: 'event.people', component: () => import('./screens/People.vue') },
  { path: 'agenda', name: 'event.agenda', component: () => import('./screens/Agenda.vue') },
  { path: 'points', name: 'event.points', component: () => import('./screens/Points.vue') },
  { path: 'plan', name: 'event.plan', component: () => import('./screens/Plan.vue') },
  { path: 'profile', name: 'event.profile', component: () => import('./screens/Profile.vue') },
  { path: 'not-on-list', name: 'event.not-on-list', component: () => import('./screens/NotOnList.vue') },
  { path: 'removed', name: 'event.removed', component: () => import('./screens/Removed.vue') },
]
